export const COMPONENT_TYPES = {
  SHARE: "share",
  WIDGET: "widget",
  CAROUSEL: "carousel",
  MOSAIC: "mosaic",
  IMAGE_FORMAT: "image_format",
  HIGHLIGHT: "highlight",
  SEARCH_PLACEHOLDER: "search_placeholder",
  FAQ: "faq",
  SEARCH: "search",
  SHORTCUT: "shortcut",
} as const;

export type ComponentTypeKeys = keyof typeof COMPONENT_TYPES;

export type ComponentType = (typeof COMPONENT_TYPES)[ComponentTypeKeys];
